import { useContext, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { ToolsContext, ToolsDispatchContext, mainToolset } from "../../ToolsContext";
import { useNewGtfsResource, useNewGtfsRoute } from "../../Queries";
import { useGtfsSuggestNewId } from "../../Queries";
import { OverlayContext } from "../../OverlaysContext";
import { NewRouteForm } from "./NewRouteForm";

export function NewRouteDialog({visible, onHide}) {
    const {status: defaultIdStatus, data: defaultId} = useGtfsSuggestNewId('routes');  
    const toolDispatch = useContext(ToolsDispatchContext);
    const handleOverlay = useContext(OverlayContext);  
    const newRouteMutation = useNewGtfsResource('routes');
    const [values, setValues] = useState({
        route_id: '',
        route_short_name: '',
        route_long_name: '',
        validation_errors: {
            route_id: false,
        }
    });

    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {handleSendData()}} autoFocus />
        </div>
    );

    function handleChangeID(e) {
        setValues({...values, route_id: e.target.value});
    }

    function handleChangeRouteShortName(e) {
        setValues({...values, route_short_name: e.target.value});
    }

    function handleChangeRouteLongName(e) {
      setValues({...values, route_long_name: e.value});
  }

    async function handleSendData() {
        const data = {
          fields: {
            route_id: (values.route_id) ? values.route_id : defaultId,
            route_short_name: values.route_short_name,
            route_long_name: values.route_long_name,
            route_color: 'ffffff',
            route_text_color: '000000',
            agency_id: 1,   // TODO: zamiast ustawiać przewoźnikan na sztywno, trzeba zrobić pole wyboru...
            route_type: 3,
            suspended: 1 
            // TODO: zrobić jakiś sensowny mechanizm określania domyślnej pozycji linii w spisie... może wyciąganie, która jest ostatnia i +1...
          }
        }
    
        try {
          const mutation = await newRouteMutation.mutateAsync(data);
          onHide();
          // po udanym dodaniu przystanku otwórz go w edytorze
          toolDispatch({
            type: 'changed',
            newTool: {
              ...mainToolset.tools.routesTool,
              selection: data.fields.route_id, // zaznacz przystanek na mapie
              propertyEditor: {   // i wyświetl w edytorze
                edit: data.fields
              }
            },
          });
          
        } catch(error) {
          const errorCode = error.message.slice(0,3);  
          if(errorCode == '422') {
            //obsługa błędów walidacji
            let updatedValidationErrors = {};
            let propertyNames = Object.keys(error.cause.validation);
            propertyNames.forEach((value) => {
              messages = Object.values(error.cause.validation[value]).join(', ');
              updatedValidationErrors[value] = messages;
            })
            setValues({
              ...values,
              validation_errors: {
                ...updatedValidationErrors
              }
            })
          } else {
            //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
              severity: "error",
              summary: 'Błąd ' + errorCode,
              detail: error.message
            })
          } 
        }   
      }    

    return (
        <Dialog header="Nowa linia" 
                footer={dialogFooterContent} 
                visible={visible} 
                style={{ width: '50vw', maxWidth: '500px' }}  
                breakpoints={{ '960px': '75vw', '641px': '100vw' }} 
                onHide={onHide}
        >
            <div className="m-0">
                {
                (defaultIdStatus === 'success' || defaultIdStatus === 'error') 
                ? 
                    <NewRouteForm 
                        values={{
                            ...values,
                            route_id: (values.route_id) ? values.route_id : defaultId,
                        }} 
                        onChangeRouteId={handleChangeID} 
                        onChangeRouteShortName={handleChangeRouteShortName}
                        onChangeRouteLongName={handleChangeRouteLongName}
                    /> 
                : 
                    <ProgressSpinner />
                }
            </div>
        </Dialog>
    )
}